import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MdArrowOutward } from "react-icons/md";
import Footer from "./Footer";
import { galleryImages, groupsData } from "../utils/constants";
import CustomButton from "./custom/CustomButton";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import { toast } from "react-toastify";
import Loader from "./custom/Loader";
import CustomContent from "./custom/CustomContent";
import CustomHeading from "./custom/CustomHeading";
import { Helmet } from "react-helmet";

export default function Groups() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 20);
    getGroups();
  }, []);

  async function getGroups() {
    try {
      setLoading(true);
      const response = await axiosStrapiInstance.get("/api/groups?populate=*&sort=groupId:asc");
      const result = response?.data?.data?.map((item) => ({
        ...item,
        image: `${item?.image?.url}`,
        galleryImages: item?.galleryImages?.map(
          (item) => `${item?.url}`
        ),
      }));
      setGroups(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while submiting form", error);
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
    }
  }
  return (
    <>
      <Helmet>
        <title>Learning & Creative Groups by Mother's Pride – From Preschool to Leadership</title>
        <meta name="description" content="Diverse ecosystem of Mother's Pride groups including Out Of The Box, Hocus Pocus, Presidium, Mom & I, and Mother’s Pride Preschool. Nurturing creativity, leadership, love, and learning under one visionary umbrella." />
        <meta name="keywords" content="Creative Groups" />
      </Helmet>
      <div className="px-[6%] py-[4%] font-Lato">
        <CustomHeading
          text={"Our "}
          spanText={"Groups"}
          textColor="#121212"
          spanTextColor="#d31c4f"
          textSize="58px"
        />

        <div className="flex mt-10 flex-col gap-10">
          {loading ? (
            <Loader />
          ) : (
            groups.map((item, index) => (
              <div
                key={index}
                className="sm:h-[360px] lg:h-[300px] sm:pb-0 pb-3 px-3 lg:px-6 bg-white rounded-2xl border border-[#e6e6e6] justify-between items-center flex sm:flex-row flex-col overflow-hidden"
              >
                <img
                  className="w-full sm:w-[200px] lg:w-[360px] h-[180px] sm:h-[260px] rounded-xl"
                  src={item?.image}
                  alt=""
                />
                <div className="sm:w-[65%] pr-[1rem] flex-col items-start justify-between inline-flex">
                  <CustomHeading
                    text={item?.title}
                    textColor="#383838"
                    textSize="32px"
                    smTextSize="24px"
                    leading="40px"
                  />
                  <CustomContent
                    marginTop="10px"
                    textAlign="justify"
                    text={`${item?.description?.substr(0, 400)}...`}
                    textColor="#383838"
                    textSize="20px"
                    leading="24px"
                  />

                  <CustomButton
                    text={"Know More"}
                    handleClick={() =>
                      navigate(`/groupsSection?section=${item?.title}`)
                    }
                  />
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      {/*  */}
      <Footer marginX={"5%"} />
    </>
  );
}
